const About = (): JSX.Element => {
  return (
    <div className="bg-white shadow-md rounded-md p-6">
      <p className="text-gray-700">
        Marvel Comics (or simply Marvel) is an American comic book publisher and
        primary imprint of Marvel Worldwide Inc. (formerly Marvel Publishing,
        Inc. and Marvel Comics Group), part of Marvel Entertainment. In 2009,
        The Walt Disney Company acquired the parent company. Marvel was started
        in 1939 by Martin Goodman as Timely Comics,[3] and by 1951 had generally
        become known as Atlas Comics. The Marvel era began in 1961, the year
        that the company launched The Fantastic Four and other superhero titles
        created by Stan Lee, Jack Kirby, Steve Ditko and many others. The Marvel
        brand, which had been used over the years, was solidified as the
        company's primary brand. Marvel counts among its characters such
        well-known superheroes as Spider-Man, Iron Man, Captain America, Thor,
        Doctor Strange, Hulk, Wolverine, and Captain Marvel, as well as popular
        superhero teams such as the Avengers, the X-Men, the Fantastic Four, and
        the Guardians of the Galaxy. Its stable of well-known supervillains
        includes the likes of Doctor Doom, Magneto, Ultron, Thanos, Green
        Goblin, Galactus, Loki, and Kingpin. Most of Marvel's fictional
        characters operate in a single reality known as the Marvel Universe,
        with most locations mirroring real-life places; many major characters
        are based in New York City.[4] Additionally, Marvel has published
        several licensed properties from other companies. This includes Star
        Wars comics twice from 1977 to 1986 and again since 2015.
      </p>
    </div>
  );
};

export default About;
